(function ($, window, document) {
    'use strict';

    window.allowOnlyNumberAndSingleDot = function (input) {
        var value = input.value || '';
        var cleaned = '';
        var hasDot = false;

        for (var i = 0; i < value.length; i += 1) {
            var char = value.charAt(i);

            if (char >= '0' && char <= '9') {
                cleaned += char;
                continue;
            }

            if (char === '.' && !hasDot) {
                cleaned += char;
                hasDot = true;
            }
        }

        if (input.value !== cleaned) {
            input.value = cleaned;
        }
    };

    $(document).on('keyup', '.js-number-dot', function () {
        window.allowOnlyNumberAndSingleDot(this);
    });
})(jQuery, window, document);
